var cilExpandLeft = ["512 512", "<rect width='32' height='480' x='464' y='16' fill='var(--ci-primary-color, currentColor)' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M144,16H16V496H144ZM112,464H48V48h64Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M416,96H378.14L208.776,255.923,376.079,416H416ZM384,379.291,255.224,256.077,384,134.478Z' class='ci-primary'/>"];

export { cilExpandLeft };

